import { render, staticRenderFns } from "./Report.pug?vue&type=template&id=23ef88db&lang=pug&external"
import script from "./Report.js?vue&type=script&lang=js&external"
export * from "./Report.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports